import UAParser from 'ua-parser-js';

export type DeviceAttributes = {
  mappedDeviceType: 'desktop' | 'mobile' | 'tablet' | 'other';
  deviceType: string;
  osName: string;
  browserEngineName: string;
};

const mapDeviceType = (deviceType?: string): DeviceAttributes['mappedDeviceType'] => {
  if (!deviceType) {
    return 'desktop';
  }

  if (deviceType === 'mobile' || deviceType === 'tablet') {
    return deviceType;
  }

  return 'other';
};

// Keep the parser version, attribute keys, and values aligned with
// IS24-media-BoniCheck-Web/lambdas/resolver/index.js (classifyUserAgent).
export const getDeviceAttributes = (userAgent: string): DeviceAttributes => {
  const { device, os, engine } = new UAParser().setUA(userAgent).getResult();
  const deviceType = device.type?.toLowerCase();

  return {
    mappedDeviceType: mapDeviceType(deviceType),
    deviceType: device.type ?? 'undefined',
    osName: os.name ?? 'undefined',
    browserEngineName: engine.name ?? 'undefined',
  };
};
